export default "__VITE_ASSET__edcd978c__"